import { BANNER_SIZE_FIELDS } from "../../bannerSize";

// Fields, defaults, and library info for this section. The editor builds its form from `fields`.
const definition = {
  order: 20,
  type: "hero_banner",
  name: "Hero Banner",
  category: "Promotional",
  description: "Rotating homepage banners. Each slide has an image, headline, and buttons.",
  defaultSettings: {
    alignment: "left",
    imageUrl: "/assets/themes/prestige-hero-v2.webp",
    mobileImageUrl: "/assets/themes/prestige-hero-v2.webp",
    bannerHeight: "large",
    bannerHeightMobile: "same",
    bannerFit: "cover",
    bannerWidth: "full",
  },
  fields: [
    {
      key: "alignment",
      label: "Content Alignment",
      type: "select",
      options: [
        { value: "left", label: "Left Aligned" },
        { value: "center", label: "Centered" },
        { value: "right", label: "Right Aligned" },
      ],
    },
    {
      key: "layout",
      label: "Banner layout",
      type: "select",
      options: [
        { value: "banner", label: "Full photo" },
        { value: "split", label: "Text and photo" },
      ],
    },
    { key: "fact1Value", label: "First highlight", type: "text", placeholder: "Warranty", showWhen: { key: "layout", value: "split" } },
    { key: "fact1Label", label: "First highlight note", type: "text", placeholder: "official stock", showWhen: { key: "layout", value: "split" } },
    { key: "fact2Value", label: "Second highlight", type: "text", placeholder: "COD", showWhen: { key: "layout", value: "split" } },
    { key: "fact2Label", label: "Second highlight note", type: "text", placeholder: "pay on delivery", showWhen: { key: "layout", value: "split" } },
    { key: "fact3Value", label: "Third highlight", type: "text", placeholder: "Support", showWhen: { key: "layout", value: "split" } },
    { key: "fact3Label", label: "Third highlight note", type: "text", placeholder: "call or WhatsApp", showWhen: { key: "layout", value: "split" } },
    { key: "stageTitle", label: "Photo label", type: "text", showWhen: { key: "layout", value: "split" } },
    { key: "stageNote", label: "Photo note", type: "text", showWhen: { key: "layout", value: "split" } },
    ...BANNER_SIZE_FIELDS,
  ],
};

export default definition;
